import { defineComponent as _defineComponent } from 'vue'
import IconMaterial from './IconMaterial.vue';
import { computed, getCurrentInstance } from 'vue';

export type Sizes = 'sm' | 'md' | 'lg';

export type Variant =
  | 'primary'
  | 'primary-flat'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'success-outline'
  | 'error'
  | 'error-outline'
  | 'warning'
  | 'warning-outline';

export interface ButtonProps {
  id?: string;
  text?: string;
  iconLeft?: string;
  iconLeftColor?: string;
  iconLeftSize?: number;
  iconLeftVariant?: string;
  iconRight?: string;
  iconRightColor?: string;
  iconRightSize?: number;
  iconRightVariant?: string;
  variant?: Variant;
  size?: Sizes;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  pending?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    id: { type: String, required: false },
    text: { type: String, required: false },
    iconLeft: { type: String, required: false },
    iconLeftColor: { type: String, required: false, default: '#64748B' },
    iconLeftSize: { type: Number, required: false, default: 16 },
    iconLeftVariant: { type: String, required: false, default: 'outlined' },
    iconRight: { type: String, required: false },
    iconRightColor: { type: String, required: false, default: '#64748B' },
    iconRightSize: { type: Number, required: false, default: 16 },
    iconRightVariant: { type: String, required: false, default: 'outlined' },
    variant: { type: String, required: false, default: 'primary' },
    size: { type: String, required: false, default: 'sm' },
    fullWidth: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false },
    pending: { type: Boolean, required: false, default: false }
  },
  emits: ['click', 'click-left-icon', 'click-right-icon'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const instance = getCurrentInstance();
const props = __props;

const iconSizeMap: Record<string, number> = {
  sm: 16,
  lg: 20,
};

const calculateTextWidth = computed(() => {
  if (!props.text) return 'width: 0px';

  const fontSize = 12;
  const charWidthRatio = 0.55; /// average character size
  const textLength = props.text.length;

  return `width: ${textLength * charWidthRatio * fontSize}px`;
});

const iconLeftSizeValue = computed(() => {
  if (props.iconLeftSize) {
    return props.iconLeftSize;
  }
  return iconSizeMap[props.size];
});

const iconRightSizeValue = computed(() => {
  if (props.iconRightSize) {
    return props.iconRightSize;
  }
  return iconSizeMap[props.size];
});

const iconnClasses = computed(() => {
  const variantClass = props.variant ? `iconn_${props.variant}` : 'iconn_primary';
  const sizeClass = `iconn_${props.size}`;
  const fullWidthClass = props.fullWidth ? 'iconn_full-width' : '';
  const disabledClass = props.disabled ? 'disabled' : '';
  return [variantClass, sizeClass, fullWidthClass, disabledClass];
});

const emit = __emit;

const handleClick = (event: MouseEvent) => {
  if (props.disabled || props.pending) {
    return;
  }
  emit('click', event);
};

const clickLeftIconHandler = (event: MouseEvent) => {
  if (props.disabled || props.pending) {
    return;
  }
  if (!instance?.vnode?.props?.onClickLeftIcon) {
    handleClick(event);
    return;
  }

  emit('click-left-icon');
};
const clickRightIconHandler = (event: MouseEvent) => {
  if (props.disabled || props.pending) {
    return;
  }
  if (!instance?.vnode?.props?.onClickRightIcon) {
    handleClick(event);
    return;
  }
  emit('click-right-icon');
};

const __returned__ = { instance, props, iconSizeMap, calculateTextWidth, iconLeftSizeValue, iconRightSizeValue, iconnClasses, emit, handleClick, clickLeftIconHandler, clickRightIconHandler, IconMaterial }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})